import Analytics from '@/mixins/Analytics';

/** Provide FF slugs from Capital remote app */
const capitalFeatureFlagsSlugs = await import('capital/featureFlagSlugs')
  .then((data) => data.default)
  .catch((e) => {
    Analytics.methods.noticeError('CAPITAL FEATURE FLAG SLUGS FAILED', e);

    return {};
  });

/** Provide FF slugs from Capital remote app */
const inventoryFeatureFlagsSlugs = await import('inventory/featureFlagSlugs')
  .then((data) => data.default)
  .catch((e) => {
    Analytics.methods.noticeError('MyInventoryV2 feature flags failed', e);

    return {};
  });

/* eslint sort-keys: "error" */ /* nop */
const featureFlagSlugs = {
  ...capitalFeatureFlagsSlugs,
  ...inventoryFeatureFlagsSlugs,
  acvProgrammaticBidding: 'acv_programmatic_bidding',
  acvProgrammaticNotifications: 'acv_programmatic_notifications',
  acvSAMSalesforceSubscription: 'acv_sam_salesforce_subscription',
  acvSam3pPrivateRules: 'sam_3p_private_rules',
  addRestrictionsToSellerControlledStartPrice: 'add_restrictions_to_seller_controlled_start_price',
  allowSellerControlledStartPriceOnLaunch: 'allow_seller_controlled_start_price_on_launch',
  arbitrationIntakeViewSubmittedArb: 'arbitration_intake_view_submitted_arb',
  arbitrationWebIntakeV2: 'arb_webintake_v2',
  auctionImpressionTrackingSrp: 'auction_impression_tracking_srp',
  auctionSellerCanKillAuction: 'auction_seller_can_kill_auction',
  biddingButtonContentUpdate: 'bidding_button_content_update',
  buyingMatrixLink: 'buying_matrix_link',
  capitalABTestingLeadGenWidgetCheckout: 'capital_abtesting_leadgenwidget_checkout',
  capitalABTestingLeadGenWidgetCheckoutB: 'capital_abtesting_leadgenwidget_checkout_b',
  capitalCheckAmountOutOfRange: 'capital_check_amount_out_of_range',
  capitalCheckoutABTesting: 'capital_checkout_a_b_testing',
  capitalInvoiceRefactor: 'capital_invoice_refactor',
  capitalLeadGenUpdates: 'capital_lead_gen_updates',
  capitalPilotAdvantage: 'capital_pilot_advantage',
  capitalShowAdvantageLeadGen: 'capital_show_advantage_lead_gen',
  capitalShowPortfolioSummary: 'capital_show_portfolio_summary',
  capitalTitleFlexProduct: 'capital_title_flex_product',
  capitalUseContractAcvAdvantage: 'capital_use_contract_acv_advantage',
  capitalUseMicrofrontend: 'capital_use_microfrontend',
  crExpiration: 'cr_expiration',
  crExpirationExempt: 'cr_expiration_exempt',
  datadogSessionReplay: 'datadog_session_replay_web',
  dealerDocsUploadDisabled: 'disable_user_dealer_docs_upload',
  displayAAIssuesAfterLogin: 'display_aa_issues_after_login',
  enableAcvLoyaltyProduct: 'enable_acv_loyalty_product',
  enableClockDriftTracking: 'enable_clock_drift_event_tracking',
  enableCrossLanePromotion: 'enable_cross_lane_promotion',
  enableDealershipAddressesAdditionalSubtypes: 'enable_dealership_addresses_additional_subtypes',
  enableDevtoolsWeb: 'enable_devtools_web',
  enableGraphqlOnSrp: 'enable_graphql_on_srp',
  enableMandatedTransport: 'enable_mandated_transport',
  enableMarketplace2RelatedRecommendations: 'marketplace_2_related_recommendations',
  enableNewFeeSchedulePage: 'enable_new_fee_schedule_page',
  enableOmsItemizedBuyFees: 'enable_oms_itemized_buy_fees',
  enableRescheduleAuctions: 'enable_reschedule_auctions',
  enableSortingOnEndedAuctionSrp: 'enable_sorting_on_ended_auctions_srp',
  enableSrpRefresh: 'enable_srp_refresh',
  enableStockwaveIntegration: 'enable_stockwave_integration',
  enableTosAcceptance: 'enable_terms_of_service_acceptance',
  enableVdp3Redesign: 'vdp_3_redesign',
  enhancedPhotoGallery: 'enhanced_photo_gallery',
  forceAuctionsFinalize: 'force_auctions_finalize',
  forceWebAppRefresh: 'force_web_app_refresh',
  getEasypostUrlContent: 'get_easypost_url_content',
  hideMarketReportMinMaxBoxes: 'market_report_hide_min_max',
  inboundShippingLabelConsolidation: 'inbound_shipping_label_consolidation',
  launchUseBulkAuctionLaunchForSingleLaunch: 'launch_use_bulk_auction_launch_for_single_launch',
  leadSendNotificationSuppression: 'lead_send_notification_suppression',
  legacySrpDefaultSortRecommended: 'legacy_srp_default_sort_recommended',
  liftListedAsReplaceDueDate: 'lift_listedas_replace_duedate',
  marketReportShowEngineDescriptionFilter: 'market_report_show_engine_description_filter',
  marketReportV2: 'market_report_v2',
  marketValueAsDefaultSortingOnEndedAuctions: 'market_value_as_default_sorting_on_ended_auctions',
  matchForecastUpdates: 'match_forecast_updates',
  myAcvDisplayedItemTracking: 'my_acv_displayed_item_tracking',
  myAcvEnableBuyerTitle: 'my_acv_enable_buyer_title',
  myAcvShowChat: 'show_my_acv_chat',
  myAcvShowCobrandingSection: 'show_cobranding_section',
  myAcvShowInvoicesMenu: 'show_my_acv_invoice_menu',
  myAcvShowSalesPerformanceInformation: 'myacv_show_sales_performance_information',
  myAcvShowStandardContactInfo: 'myacv_show_standard_contact_info',
  myAcvShowTitleProgressDetails: 'myacv_show_title_progress_details',
  myInventoryAddGuaranteedSaleOffers: 'my_inventory_add_guaranteed_sale_offers',
  myInventoryAddNoReserveSchedules: 'my_inventory_add_no_reserve_schedules',
  myInventoryCms: 'my_inventory_cms',
  myInventoryDefaultLaunchValues: 'my_inventory_default_launch_values',
  myInventoryEnabled: 'my_acv_my_inventory',
  myInventoryMigrateVdpSaDelete: 'my_inventory_migrate_vdp_sa_delete',
  myInventoryRequestInspectionSpecialFields: 'my_inventory_request_inspection_special_fields',
  myInventoryUseMicrofrontend: 'my_inventory_use_microfrontend',
  nearReserveBadgeSeenTracking: 'near_reserve_badge_seen_tracking',
  offersAndNegotiationsMaximumOfferRestriction: 'offers_and_negotiations_maximum_offer_restriction',
  offersAndNegotiationsProxyBidCounter: 'offers_and_negotiations_proxy_bid_counter',
  offersAndNegotiationsSplitDifference: 'offers_and_negotiations_split_difference',
  passwordResetRequest: 'password_reset_request',
  paymentChargeFloorplanFacilitationFee: 'payment_charge_floorplan_facilitation_fee',
  photoViewedTracking: 'photo_viewed_tracking',
  privateAuctionsUseMinOfferAmount: 'private_auctions_use_min_offer_amount',
  qeMigrateRecentToSS: 'qe_migrate_recent_to_ss',
  requestOffPlatformTransportation: 'request_off_platform_transportation',
  requireEulaAcceptanceForLanes: 'require_eula_acceptance_for_lanes',
  reserveMetBadgeSeenTracking: 'reserve_met_badge_seen_tracking',
  restrictManageUserToPrimaryContact: 'restrict_manage_users_to_primary_contact',
  restrictOffer: 'restrict_offer',
  savedSearchConditionExclusions: 'saved_search_condition_exclusions',
  savedSearchConditionExclusionsDealerships: 'saved_search_condition_exclusions_dealerships',
  savedSearchTemplates: 'saved_search_templates',
  setSavedAuctionContext: 'market_report_set_saved_auction_context',
  shouldInitializePendo: 'should_initialize_pendo',
  showAcvCalculatedValue: 'ent_micro_pricing_acv_calc_data',
  showAddClerkTour: 'show_add_clerk_acv_tour',
  showAddClerkTourABTest: 'show_add_clerk_acv_tour_a_b_test',
  showAutosellFilterTypeInMarketplace: 'show_autosell_filter_type_in_marketplace',
  showBuyerStateTitleRequirements: 'show_buyer_state_title_requirements',
  showCheckoutTransportationMessage: 'show_checkout_transportation_message',
  showClearCarAppraisalTab: 'acv_header_drivably_appraisal_tab',
  showDigitalRunSheet: 'digital_run_sheet_web',
  showDigitalRunSheetAcvCalculatedValue: 'digital_run_sheet_show_sweet_spot',
  showDigitalRunSheetFeedbackWidget: 'digital_run_sheet_feedback_widget',
  showEstimateMakeOffer: 'show_estimate_make_offer',
  showEstimateOfferDashboard: 'show_estimate_offer_dashboard',
  showFinalOfferButton: 'show_final_offer_button',
  showFloorPriceInMarketReport: 'market_report_floor_price_visible',
  showInvoicesToBillingContact: 'show_invoices_to_billing_contact',
  showLowReserveBadgeSellerAuctions: 'show_low_reserve_badge_seller_auctions',
  showMarketReportFewResults: 'market_report_show_few_results',
  showMarketReportInAuctionLaunchIOS: 'market_comp_link_ios',
  showMarketReportTabIOS: 'market_comp_tab_ios',
  showNegotiationsOnMyAcvOffersTab: 'show_negotiations_on_myacv_offers_tab',
  showOfferRejectionOptions: 'show_offer_rejection_options',
  showOffersOnSavedAuctionsScreen: 'show_offers_on_saved_auctions_screen',
  showOffersPageForBuyers: 'show_offers_page_for_buyers',
  showOutstandingTitleDetails: 'show_outstanding_title_details',
  showPaymentMethods: 'assembly_payments_in_app',
  showPaymentSettings: 'vue_payment_settings',
  showPriceRangeInMarketReportBadge: 'show_price_range_in_market_report_badge',
  showPricingInspectionInfo: 'show_pricing_inspection_info',
  showRecommendedSortOnLiveAuctionsWeb: 'show_recommended_sort_on_live_auctions_web',
  showReportIssue: 'show_report_issue',
  showSavedAuctionLaunchGoGreenDisclaimer: 'saved_auction_launch_go_green_disclaimer',
  showSellerDashboard: 'show_seller_dashboard',
  showSellerDetailsInVdp: 'show_seller_details_in_vdp',
  showSellerLastEngagedDate: 'show_seller_last_engaged_date',
  showSellerUpdateTemplate: 'show_seller_update_template',
  showUrgentTitles: 'show_urgent_titles',
  showVectorImageSearchWeb: 'show_vector_image_search_web',
  showWebReloadPromptAfterDeployment: 'show_web_reload_prompt_after_deployment',
  titleManagementRedesign: 'title_management_redesign',
  transportCheckoutMultipleDeliveryAddress: 'transport_checkout_multiple_delivery_address',
  transportCheckoutV3: 'transport_checkout_v3',
  transportOffPlatformAddressSelection: 'transport_offplatform_address_selection',
  transportOffPlatformManageGatepass: 'transport_offplatform_manage_gatepass',
  transportationAfterAuctionInApp: 'transportation_after_auction_in_app',
  transportationDriveaway: 'transportation_driveaway',
  transportationEnclosed: 'transportation_enclosed',
  transportationHubMultiVehicleOrder: 'transportation_hub_multi_vehicle_order',
  transportationHubReleaseSlipFileUpload: 'transportation_hub_release_slip_file_upload',
  transportationRedirectCreateBulkRequestToTyk: 'transport_create_bulk_request_redirect_to_tyk',
  transportationRedirectGatePassToTyk: 'transport_gate_pass_redirect_to_tyk',
  transportationRedirectGetQuoteToTyk: 'transport_get_quote_redirect_to_tyk',
  transportationRedirectVinDecodeToTyk: 'transport_vin_decode_redirect_to_tyk',
  transportationSearchRequestRedirectToTyk: 'transport_search_request_redirect_to_tyk',
  transportationStatusLink: 'transportation_status_link',
  transportationUseMicrofrontend: 'transportation_hub_use_microfrontend',
  urgentTitleRedesign: 'urgent_title_redesign',
  useBffEndpointForNegotiationBuying: 'use_bff_endpoint_for_negotiation_buying',
  useBffEndpointForNegotiationSelling: 'use_bff_endpoint_for_negotiation_selling',
  useOpenMarketplaceOffers: 'use_open_marketplace_offers',
  webMyAcvActiveBuyingUseBff: 'web_myacv_active_buying_use_bff',
  webMyAcvAuctionListV2: 'web_myacv_auction_list_v2',
};

export default featureFlagSlugs;
